import React, { useEffect, useState } from "react";
import API from "../utils/axiosInstance";
import "./Profile.css";
import { useTranslation } from "react-i18next";  // ✅ i18n

const Profile = () => {
  const { t } = useTranslation();  // ✅ init
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await API.get("users/profile");
        setProfile(res.data);
      } catch (err) {
        console.error("Failed to fetch profile:", err);
      }
    };

    fetchProfile();
  }, []);

  if (!profile) return <div>{t("Loading")}</div>; // ✅ Translated fallback

  return (
    <div className="edit-profile-container">
      <h2 className="profile-title">{t("UserProfile")}</h2>

      <div className="profile-image-container">
        <img
          src={profile.profileImage || "/images/profile.svg"}
          alt="Profile"
          className="profile-image"
        />
      </div>

      <div className="profile-info-grid">
        <div className="profile-info-row">
          <span className="profile-label">{t("FullName")}</span>
          <span className="profile-value">{profile.name}</span>
        </div>
        <div className="profile-info-row">
          <span className="profile-label">{t("Email")}</span>
          <span className="profile-value">{profile.email}</span>
        </div>
        <div className="profile-info-row">
          <span className="profile-label">{t("PhoneNumber")}</span>
          <span className="profile-value">{profile.phone || '-'}</span>
        </div>
      </div>
    </div>
  );
};

export default Profile;
